import { ReactComponent as EarthSvg } from "./earth2.svg";

const Earth = () => {
  return <EarthSvg />;
};

export default Earth;
